import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Apple: React.FC<IconProps> = ({ size, style, color }) => {
  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" width={size ?? '20'} height={size ?? '21'} fill="none" viewBox="0 0 20 21" data-testid="apple-icon">
      <path
        d="M14.5977 10.8633C14.5898 9.53125 15.1934 8.52734 16.4121 7.78711C15.7305 6.81055 14.6992 6.27344 13.3398 6.16992C12.0527 6.06836 10.6445 6.91992 10.1289 6.91992C9.58398 6.91992 8.33789 6.20508 7.35742 6.20508C5.33398 6.23633 3.18359 7.81836 3.18359 11.0371C3.18359 11.9883 3.35742 12.9707 3.70508 13.9824C4.16992 15.3145 5.8457 18.5781 7.59375 18.5254C8.50781 18.5039 9.1543 17.877 10.3437 17.877C11.498 17.877 12.0957 18.5254 13.1152 18.5254C14.8789 18.5 16.3945 15.5332 16.8359 14.1973C14.4707 13.082 14.5977 10.9316 14.5977 10.8633ZM12.5449 4.90625C13.5352 3.73047 13.4453 2.66016 13.416 2.27539C12.541 2.32617 11.5293 2.87109 10.9531 3.54102C10.3184 4.25977 9.94531 5.14844 10.0254 6.15039C10.9707 6.22266 11.834 5.73633 12.5449 4.90625Z"
        fill={color ?? '#fff'}
      />
    </svg>
  );
};

export default Apple;
